<template>
<v-container>
  <h2>
    担当者の権限を変更する
  </h2>
  <br>
  <div class="mb-3 body-2">
    OilMatrixに登録しているユーザー（担当者）権限の変更について説明します。<br>
    本メニューはユーザー権限が「管理者」のユーザーのみが利用可能です。
  </div>

    <div class="my-8 mb-4">
      <h3>担当者権限の種類</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      担当者の権限には下記の種類があります。
    </div>

    <v-row class="ml-4" dense>
      <v-col cols="2" align="center">
        <v-chip color="amber darken-1"><span class="white--text">管理</span></v-chip>
      </v-col>
      <v-col cols="10">
        <span class="body-2">管理者です。担当者の権限を変更したり、OilMatrixの利用を許可することができます。</span>
      </v-col>
    </v-row>

    <v-row class="ml-4" dense>
      <v-col cols="2" align="center">
        <v-chip color="success"><span class="white--text">一般</span></v-chip>
      </v-col>
      <v-col cols="10">
        <span class="body-2">一般担当者です。OilMatrixを利用できます。</span>
      </v-col>
    </v-row>

    <v-row class="ml-4" dense>
      <v-col cols="2" align="center">
        <v-chip color="grey darken-1"><span class="white--text">未許可</span></v-chip>
      </v-col>
      <v-col cols="10">
        <span class="body-2">OilMatrixの利用権限がないユーザーです。</span>
      </v-col>
    </v-row>

    <div class="my-8 mb-4">
      <h3>担当者画面への行き方</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      メニューの「担当者」をクリックすると、担当者画面が開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-confirm-01.png" width="70%" class="my-2">
    </div>

    <div class="my-8 mb-4">
      <h3>担当者権限の変更のしかた</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      担当者リストから、権限を変更する担当者をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-auth-02.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      担当者詳細画面が開いたら、画面下部の「担当者の権限変更」から設定する権限を選択し、「権限を変更する」をクリックします。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-auth-03.png" width="70%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      確認ウィンドウにて、名前と権限を確認し、「変更する」ボタンをクリックすると権限を変更できます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-auth-04.png" width="60%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      ※権限を反映するために、権限を変更したユーザーは再ログインしてください。
    </div>

    <div class="body-2" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          担当者画面の各項目の説明は下記マニュアルをご確認ください。
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manEmployeeConfirm')">
            「担当者一覧を確認する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

</v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: ''
    }),
    methods: {
      showMan: async function(value) {
      var url = '/UserManual/' + value
      this.$router.push(url)        
      }
    }
}
</script>

